import React from 'react';
import {Pressable, Text, StyleSheet, Platform} from "react-native";
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';

const styles = StyleSheet.create({
    button: {
        position: Platform.OS === 'web' ? ('fixed' as any) : 'absolute',
        bottom: 50,
        left: '50%',
        transform: [{translateX: -100}],
        backgroundColor: 'black',
        borderRadius: 40,
        paddingVertical: 12,
        paddingHorizontal: 16,
        flexDirection: 'row',
        alignItems: 'center',
        minWidth: 200,
        justifyContent: 'center',
        zIndex: 999,
        elevation: 999,
    },
    buttonText: {
        fontSize: 16,
        color: 'white',
        fontWeight: '600',
        marginLeft: 8
    }
});

/**
 * Floating action button that toggles between Camp List and Camp Map views on the Explore page.
 * When in List view, displays "Map View" to switch to map; when in Map view, displays "List View".
 */

const CampSessionSwitchButton = ({isListView, setListView}) => {
    return (
        <Pressable 
            style={styles.button}
            onPress={() => setListView(!isListView)}
        >
            <MaterialCommunityIcons 
                name={isListView ? 'map' : 'view-list'} 
                size={20}
                color='white'
            />
            <Text style={styles.buttonText}>
                {isListView ? 'Map View' : 'List View'}
            </Text>
        </Pressable>
    )
};

export default CampSessionSwitchButton;